import resolve from '../../../../modules/api/resolve';
import { apiGet, apiStore } from '../../../../modules/apiHelper';
import { isStaleData } from '../../../../modules/dataHelper';

export default {
  async getPackages() {
    const packages = await resolve(apiGet('pack_list', 14));

    return (packages || {}).pack_list; // TODO change the property
  },
  // finds by packid
  async getMenteePackage(context, refresh = false) {
    const menteeid = context.rootState.User.id; // get mentee id

    // check apiStore first
    const packageApiStore = await apiStore.getItem(`package/${menteeid}`) || [0, {}];

    if (!refresh && !isStaleData(packageApiStore[0]) && packageApiStore[1].id) {
      context.commit('updateProp', ['package', packageApiStore]);
      return packageApiStore[1];
    }

    const [mentee, packages] = await Promise.all([
      context.dispatch('getUserData', menteeid), // get mentee packageid
      context.dispatch('getPackages'), // get packages
    ]);


    // find
    const menteePackage = packages.find(p => Number(p.id) === Number(mentee.packageid)) || {};
    console.log(packages, menteePackage);
    // const menteePackage = {
    //   amount: '900',
    //   dateOfPost: '2021-06-12 16:50:36',
    //   description: '30 days of mentorship',
    //   discount: '0',
    //   discount_amount: '0',
    //   discount_days: '0',
    //   duration: '30',
    //   duration_stat: '1',
    //   id: '1',
    //   name: 'Start up Pack',
    //   pillarid: '2',
    //   status: '0',
    //   tym: '0',
    // };

    // save data
    context.commit('updateProp', ['package', menteePackage]);
    context.commit('updateProp', ['licenseStartDate', mentee.licensestartdate]);
    context.commit('updateProp', ['licenseExpiry', mentee.licenseenddate]);

    if (menteePackage.id) {
      apiStore.setItem(`package/${menteeid}`, menteePackage);
    }

    return menteePackage;
  },
  // saves selected package to vuex and apiStore
  selectPackage(context, packageId) {
    console.log(packageId);
  },
  buyPackage() {},
};
